import { render, staticRenderFns } from "./ReportAggiungiSegnalazione.vue?vue&type=template&id=20fe8448&scoped=true&lang=pug&"
import script from "./ReportAggiungiSegnalazione.vue?vue&type=script&lang=ts&"
export * from "./ReportAggiungiSegnalazione.vue?vue&type=script&lang=ts&"
import style0 from "./ReportAggiungiSegnalazione.vue?vue&type=style&index=0&id=20fe8448&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe8448",
  null
  
)

export default component.exports